import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { Home, ArrowLeft, AlertTriangle } from 'lucide-react';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const handleGoHome = () => {
    if (user?.role) {
      navigate(`/dashboard/${user.role}`);
    } else {
      navigate('/dashboard');
    }
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const getRoleSpecificMessage = () => {
    switch (user?.role) {
      case 'student':
        return 'This page is not available in your student portal.';
      case 'teacher':
        return 'This page is not available in your teacher portal.';
      case 'parent':
        return 'This page is not available in your parent portal.';
      case 'staff':
        return 'This page is not available in your staff portal.';
      default:
        return 'This page is not available.';
    }
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardContent className="p-8 text-center">
          <div className="mb-6">
            <AlertTriangle className="w-16 h-16 mx-auto text-yellow-500 mb-4" />
            <h1 className="text-3xl font-bold text-gray-900 mb-2">404</h1>
            <h2 className="text-xl font-semibold text-gray-700 mb-2">Page Not Found</h2>
            <p className="text-gray-600 mb-4">
              The page you're looking for doesn't exist.
            </p>
            <p className="text-sm text-gray-500 mb-6">
              {getRoleSpecificMessage()}
            </p>
          </div>

          <div className="space-y-3">
            <Button onClick={handleGoHome} className="w-full">
              <Home className="w-4 h-4 mr-2" />
              Go to Dashboard
            </Button>
            <Button onClick={handleGoBack} variant="outline" className="w-full">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>

          {process.env.NODE_ENV === 'development' && (
            <div className="mt-6 p-3 bg-gray-100 rounded text-left">
              <p className="text-xs text-gray-600">
                <strong>Debug Info:</strong><br />
                Path: {location.pathname}<br />
                Role: {user?.role || 'Not logged in'}
              </p>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
